
import Vue from 'vue'
import {Component, Watch} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import EssaiForm from '@/components/forms/EssaiForm.vue'
import VueScrollTo from 'vue-scrollto'

const prospectModule = namespace('prospect')
const essaiModule = namespace('essai')

@Component({
  components: {
    BaseCardContainer,
    EssaiForm
  }
})
export default class ProspectAlerteUpdate extends Vue {
  @essaiModule.Getter('essaiGetter') essai: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @prospectModule.Getter('prospectGetter') prospect: any
  @essaiModule.Action('getEssaiByIdAction') getEssaiById: any
  @essaiModule.Action('updateEssaiAction') updateEssai: any

  get relation() {
    return {
      to: 'prospect',
      key: 'ID_PROSPECT',
      value: this.$route.params.id
    }
  }

  mounted() {
    this.getEssaiById(this.$route.params.essaiId)
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  @Watch('$route.params.essaiId', {immediate: true, deep: false})
  onUrlChange(newVal: any) {
    this.getEssaiById(newVal)
  }

  onSubmit(data: any) {
    this.updateEssai({
      id: this.$route.params.essaiId,
      formParams: data
    }).then(async (data: any) => {
      await this.getProspectById(this.$route.params.id)
      this.$router.push({name: 'prospectEssai', params: {id: this.$route.params.id}})
    })
  }

  onCancel() {
    this.$router.push({name: 'prospectEssai', params: {id: this.$route.params.id}})
  }
}
